var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab12aede-5cec-46d5-beeb-cdc0af7bb3d2",
    "data-name": "a3d02f77-e796-4c82-97eb-8e51f9ce2cb0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".acfdea84-c9c4-4693-9f76-3743052773a3{fill:#e0fc00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b40bc819-b034-4c0b-b3cb-d157f28bd266",
    "data-name": "bd2f2c66-4083-4f1b-ad25-30633becb7ca"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "be6208a6-726b-4938-b13f-33a0e5feca62",
    "data-name": "b23f3cea-c125-4850-bfa3-c1a2d3746557",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 25.5,
    cy: 14.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bfb7238f-e589-43cf-b7da-a26500ea1d21",
    "data-name": "f89bf8ab-89d1-4608-aa21-7037185a4c3a",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 25.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a7629a83-1651-4a5e-9287-682c50ce9601",
    "data-name": "e51e09e8-6382-4f4d-9c8f-12b71be46229",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 25.5,
    cy: 25.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "efe8514b-de1e-47e1-bb5c-e094edcb25a2",
    "data-name": "a15b0b76-c487-4adc-8aef-06512a9a69c9",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 14.5,
    cy: 14.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "fc283a07-a9c0-4f5b-a035-38d0b443cd70",
    "data-name": "b2ade1b3-5da1-457e-b210-98ceb3e0d3a3",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 14.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "af219448-598a-42f0-961b-aa1b9d621282",
    "data-name": "f8022cf0-b693-4c5d-b87f-101635e5ab3e",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 14.5,
    cy: 25.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e9c0647a-e00b-44b1-9ef3-778f70f75fe0",
    "data-name": "e22cfc88-2193-432c-930c-7ae460335969",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 3.5,
    cy: 14.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b4188faa-beab-4937-ac90-308356903274",
    "data-name": "a1e3f50e-deb1-4121-a901-eca79497ac76",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b2c10af0-a28e-446b-8db1-e3e9d8a993e5",
    "data-name": "b0fa0a57-7137-482f-9356-e2511c6f7227",
    className: "acfdea84-c9c4-4693-9f76-3743052773a3",
    cx: 3.5,
    cy: 25.5,
    r: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobileMenu.eb3c84de89eb061e65a943077ddc728e.svg";
export { ForwardRef as ReactComponent };